import { apiRequest } from './client.js';
export async function fetchActiveSeason() {
    return apiRequest('/seasons/active');
}
export async function createSeason(title) {
    return apiRequest('/seasons', {
        method: 'POST',
        body: { title },
        auth: true,
    });
}
export async function updateSeason(seasonId, title) {
    return apiRequest(`/seasons/${seasonId}`, {
        method: 'PATCH',
        body: { title },
        auth: true,
    });
}
